
import { useEffect, useState } from 'react'
import { AccountSchema } from "../data/types";
import { useCompleteSignIn, useUpdateAccountDetails } from '../hooks/authhooks'
import { getChangedAttributes } from '../utils/helpers'
import { Cancel } from '@mui/icons-material'





const NoEmailBanner = ({signInModalIsOpen}: {signInModalIsOpen: boolean}) => {

  const [showBanner, setShowBanner] = useState<boolean>(true)
  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <>
      {showBanner && (
        <div className="w-full fixed mt-16 top-0 z-20 bg-[#FFF6E5] border-b border-[#FAD7A0] text-[#6B4E16] font-open-sans text-sm">
          <div className="w-11/12 sm:w-10/12 mx-auto py-3 flex items-center gap-3">
            <span className="font-semibold font-raleway">Missing email address</span>
            <span className="hidden sm:inline font-open-sans">Add your email to complete your account setup.</span>
            <button onClick={() => setIsOpen(true)} className="ml-auto bg-primaryDark-0 hover:bg-primaryDark-300 text-white font-raleway font-semibold text-[12px] rounded-md px-3 py-2 border-0">Add Email</button>
            {/* <button aria-label="Dismiss" onClick={() => setShowBanner(false)} className="ml-2 text-[#6B4E16] hover:text-[#3d2c0d] text-lg border-0">×</button> */}
          </div>
        </div>
      )}

      {
        isOpen && (
          <AddEmailModal isOpen={isOpen} setIsOpen={setIsOpen} setShowBanner={setShowBanner} />
        )
      }

  </>
  )
}

export default NoEmailBanner;



type AddEmailModalProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  setShowBanner: (showBanner: boolean) => void
}

const AddEmailModal: React.FC<AddEmailModalProps> = ({isOpen, setIsOpen, setShowBanner}) => {

  const { user } = useCompleteSignIn();
  const loggedinUid = (user && user?.uid) ? user.uid : ""
  const { updateAccount } = useUpdateAccountDetails(loggedinUid)

  const [emailInput, setEmailInput] = useState<string>("")
  const [submitting, setSubmitting] = useState<boolean>(false)
  const [error, setError] = useState<string>("")

  useEffect(() => {
    if (user && user.email) {
      setEmailInput(user.email)
    }
  }, [user])

  const validateEmail = (email: string) => {
    if (!email) return false
    const re = /[^\s@]+@[^\s@]+\.[^\s@]+/
    return re.test(email)
  }

  const handleSaveEmail = async () => {
    setError("")
    if (!validateEmail(emailInput)) {
      setError('Enter a valid email address')
      return
    }
    try {
      setSubmitting(true)
      const originalData = user ? user : {} as AccountSchema
      const newDetails: AccountSchema = {
        ...originalData,
        username: emailInput,
        email: originalData?.email ? originalData.email : emailInput
      }
      const changed = getChangedAttributes(originalData, newDetails)
      if (Object.keys(changed).length > 0) {
        await updateAccount(changed)
      }
      setIsOpen(false)
      setShowBanner(false)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? 'flex' : 'hidden'} items-start mt-16 justify-center`}>
      <div className="fixed inset-0 bg-white bg-opacity-90 z-40" onClick={() => setIsOpen(false)}></div>
      <dialog
        className="z-50 my-auto sm:w-[478px] w-11/12 max-w-[520px] h-auto bg-[#fff] p-4 rounded-xl shadow-[#00000029] shadow-[0_0px_8px_rgba(0,0,0,0.16)]"
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div className="flex flex-row justify-end">
          <span onClick={() => setIsOpen(false)} className="ml-auto w-full flex cursor-pointer">
            <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
          </span>
        </div>
        <div className="p-2">
          <p className="text-[18px] font-raleway text-black font-semibold mb-2">Add your email</p>
          <p className="text-[14px] font-open-sans text-[#808080] mb-4">We use your email as your HomeCook username.</p>
          <form onSubmit={(e) => { e.preventDefault(); handleSaveEmail(); }}>
            <div className="flex flex-col text-[14px] font-raleway text-black font-semibold">
              Email Address
              <input
                type="email"
                name="email"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                placeholder="Enter your email address"
                className="border-[1px] border-[#E9E9E9] rounded-md my-2 h-[50px] text-[14px] text-[#808080] font-normal font-open-sans px-3"
                required
              />
              {error && <span className="text-[#D42620] text-xs font-open-sans">{error}</span>}
            </div>
            <button type="submit" disabled={submitting || !loggedinUid} className={`mt-4 ${submitting ? 'bg-primaryDark-200' : 'bg-primaryDark-0 hover:bg-primaryDark-300'} text-white font-raleway font-bold text-[14px] rounded-md border-0 py-[12px] w-full`}>
              {submitting ? 'Updating…' : 'Update Account Email'}
            </button>
          </form>
        </div>
      </dialog>
    </div>
  )
}